<div class="star-rating ">
  <div *ngFor="let star of stars">
    <i class="fa" [ngClass]="getStarType(star)"></i>
  </div><br>
</div>
<br>
    <div class="fw-bold mb-3" *ngIf="showRating">({{ rating? rating : 0 }})</div>
  
  